<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">练习成绩统计</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <el-form-item>
              <el-input v-model="formInline.name" placeholder="测试名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small">搜索</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" border style="width: 100%">
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="name" label="测试名称" min-width="100"></el-table-column>
            <el-table-column label="练习记录" width="120">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">900</el-button>
              </template>
            </el-table-column>
            <el-table-column label="练习学员人数" width="120">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">900</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="1" label="平均分数" min-width="100"></el-table-column>
            <el-table-column prop="city" label="满分" min-width="100"></el-table-column>
            <el-table-column prop="1" label="最高分" min-width="100"></el-table-column>
            <el-table-column prop="2" label="最低分" min-width="100"></el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pageSize"
            :total="totalCount"
            :page-count="totalPage"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="prevPage"
            @next-click="nextPage"
            layout="total, sizes,prev, pager, next,  jumper"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
export default {
  name: "totalResult",
  data() {
    return {
      pageSize: 10, // 每页显示个数
      totalPage: 10, // 总页数
      totalCount: 20, // 总条目数
      currentPage: 1, // 当前页
      formInline: {
        name: ""
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        }
      ]
    };
  },
  components: {
    HeaderCom
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    // 每页数
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 上一页
    prevPage() {
      // console.log('上一页');
    },
    // 下一页
    nextPage() {
      // console.log('下一页');
    },
    // 批量打印培训证明
    batchPrint() {
      this.$confirm("确认打印培训证明吗?", "批量打印培训证明", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "打印成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table {
  max-height: 630px;
  overflow: auto;
}
.cont {
  margin-top: 30px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
</style>
